export var LabelGroup;
(function (LabelGroup) {
    LabelGroup["ASSIGNEE"] = "ASSIGNEE";
    LabelGroup["INBOX"] = "INBOX";
    LabelGroup["CHAT"] = "CHAT";
})(LabelGroup || (LabelGroup = {}));
export var LabelType;
(function (LabelType) {
    LabelType["SYSTEM"] = "SYSTEM";
    LabelType["CUSTOM"] = "CUSTOM";
    LabelType["USER_ID"] = "USER_ID";
})(LabelType || (LabelType = {}));
//# sourceMappingURL=types.js.map